import { validator } from "LIB/validate-this";
import * as rules from "LIB/validation/rules";
import { validateShippingFields } from "MODULES/PurchaseOrders/shared/validations";
import { CO_BUYER_ID, THIRD_BUYER_ID } from "MODULES/users/constants";
import { COMPANY_ID, CONTACT_ID, PAYMENT_TERMS } from "APP_ROOT/constants";

export default function validate(values) {
  return validator(values, v => {
    v.validate(COMPANY_ID, CONTACT_ID, PAYMENT_TERMS).satisfies(rules.required);
    if (values.buyer_credit_pct <= 50.0) {
      v.validate(CO_BUYER_ID).satisfies(rules.required);
    }

    if (values.buyer_credit_pct <= 37.5) {
      v.validate(THIRD_BUYER_ID).satisfies(rules.required);
    }
  });
}

export function validateShipping(values) {
  return validator(values, v => validateShippingFields(values, v));
}



// WEBPACK FOOTER //
// ./app/modules/Lots/Detail/Edit/EditVendor/validate.js